import { tv } from 'tailwind-variants'

export const rightComponentVariants = tv({
  slots: {
    iconStyle: 'flex text-kilo'
  }
})
